import React from "react";
import Button from "../../../../../Components/FormElements/Button";
import warningIcon from "../../../../../Resources/svg/danger-alert.svg";
import { FieldValues, OnSubmit } from "react-hook-form";
import { InputField } from "../../../../../Components/FormElements/InputField";
import { formatNumber, percentageFormat } from "../../../../../Utils/utils";
import AlertMessage from "../../../../../Components/alertMessage";
import InputNumber from "../../../../../Components/inputNumber";
import ErrorCustom from "../../../../../Components/errorCustom";
import moment from "moment";

interface FormRecalculateModalityProps {
  handleSubmit: (
    callback: OnSubmit<FieldValues>
  ) => (e?: React.BaseSyntheticEvent) => Promise<void>;
  onSubmitReCalculate: (values: any) => Promise<void>;
  errorDate: any;
  selectDate1: any;
  setValue: any;
  register: any;
  errors: any;
  showWarning: boolean;
  data: any;
  dataRecalculate: any;
  hasModalityData: any;
  modalityData: any;
  exchangeRate: number | null
  handleDateChange: (initDate: any, typeDate: any) => void;
  validateInitialValue: (monto: any, initialValue: any) => void;
}

const FormRecalculateModality = ({
  handleSubmit,
  onSubmitReCalculate,
  errorDate,
  selectDate1,
  setValue,
  register,
  errors,
  showWarning,
  data,
  dataRecalculate,
  handleDateChange,
  validateInitialValue,
  hasModalityData,
  modalityData,
  exchangeRate
}: FormRecalculateModalityProps) => {
  return (
    <form onSubmit={handleSubmit((values) => onSubmitReCalculate({ ...values, exchangeRate }))} className="clientForm">
      <div className="vasForm__form__input-container-select">
        <InputField
          disabled
          defaultValue={formatNumber.new(
            parseFloat(data.fondo.capitalPension).toFixed(2)
          )}
        />
      </div>
      <div className="vasForm__form__input-container-select">
        <label>Fecha TC Recal. 1</label>
        <InputField
          disabled
          defaultValue={selectDate1 ? moment(selectDate1).format("DD/MM/YYYY") : ""}
        />
      </div>
      <div className="vasForm__form__input-container-select">
        <label>CIC definitivo 1</label>
        {showWarning && (
          <AlertMessage
            background="#FFEFD8"
            margin="0 0px 20px"
            icono={warningIcon}
            mensaje="El monto ingresado excede en más del 20% al monto inicial."
          />
        )}
        <InputNumber
          nameVal="cic"
          setValue={setValue}
          register={register}
          thousandSeparator={","}
          validatorInput={(value: any) =>
            validateInitialValue(value, data.fondo.capitalPension)
          }
          init={0}
        />
        <ErrorCustom errors={errors} name="cic" />
      </div>
      {dataRecalculate && (
        <div className="card-verify verify-approved box-widthout-border ">
          <div className="card-verify__body">
            <div className="card-verify__quote">Prima única AFP:</div>
            <div className={`card-verify__data is-label`}>
              {dataRecalculate.respuestaMacro
                ? dataRecalculate.respuestaMacro.primaAfp
                : "--"}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Prima Única CIA:</div>
            <div className={`card-verify__data is-label`}>
              {dataRecalculate.respuestaMacro
                ? dataRecalculate.respuestaMacro.primaCia
                : "--"}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Tipo de cambio:</div>
            <div className={`card-verify__data is-label`}>
              {exchangeRate || dataRecalculate.modalidad.tipoCambio}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Renta vitalicia:</div>
            <div className={`card-verify__data is-label`}>
              {dataRecalculate.respuestaMacro
                ? dataRecalculate.respuestaMacro.primaPensionRv
                : "--"}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Renta temporal:</div>
            <div className={`card-verify__data is-label`}>
              {dataRecalculate.respuestaMacro
                ? dataRecalculate.respuestaMacro.primaPensionRt
                : "--"}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Tasa venta:</div>
            <div className={`card-verify__data is-label`}>
              {hasModalityData
                ? modalityData.tasaVenta ||
                  modalityData.tasaInteresRVD ||
                  modalityData.tasaInteresRT ||
                  0
                : 0}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">TIR:</div>
            <div className={`card-verify__data is-label`}>
              {dataRecalculate.respuestaMacro
                ? percentageFormat(dataRecalculate.respuestaMacro.tir)
                : "--"}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">VAN:</div>
            <div className={`card-verify__data is-label`}>
              {dataRecalculate.respuestaMacro
                ? dataRecalculate.respuestaMacro.van
                : "--"}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Pérd. contable:</div>
            <div className={`card-verify__data is-label`}>
              {dataRecalculate.respuestaMacro && dataRecalculate.respuestaMacro.perdida
                ? percentageFormat(dataRecalculate.respuestaMacro.perdida)
                : "--"}
            </div>
          </div>
        </div>
      )}
      <div className="actions">
        <Button type="submit" className="btn is-secondary actions__cancel">
          Procesar
        </Button>
      </div>
    </form>
  );
};

export default FormRecalculateModality;
